import React, { useState, useEffect } from 'react';

/* Common */
import { Modal, Button, PriceFormat } from '~/components/common';

/* Icons */
import ChevronIcon from '~/../symbols/chevron.svg';

/* Image */
import geldLenenKostGeld from '~/../img/let-op-geld-lenen-kost-geld.svg';

export default function CreditTable({ name, creditTableData, creditTableSnippetData, openByDefault, vehicleData }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (openByDefault) {
            setOpen(true);
        }
    }, [openByDefault, vehicleData]);

    return (
        <>
            {!openByDefault && (
                <Button
                    className="p-0 font-weight-normal btn--with-circle--xs card__credit-table-link"
                    theme='black'
                    title='Berekenen'
                    icon={ChevronIcon}
                    iconSize={14}
                    iconClassName={'icon--circle-xs'}
                    withCircle={true}
                    attributes={{ type: 'button' }}
                    onClick={(e) => { e.preventDefault(); setOpen(true); }}
                />
            )}
            <Modal
                className="modal--credit-table"
                open={open}
                handleClose={() => setOpen(false)}
                modalTitle="Krediettabel"
                modalBody={
                    <>
                        <div className="let-op-geld-lenen-kost-geld mb-2 mb-xl-6">
                            <img
                                className="let-op-geld-lenen-kost-geld__img img-fluid"
                                src={geldLenenKostGeld}
                                alt="Let op! Geld lenen kost geld"
                                width="400"
                                height="30"
                            />
                        </div>
                        <h5 className="h5 mb-0"><strong>Krediettabel</strong></h5>
                        <p className="mb-2 mb-xl-6">{name}</p>
                        <div className="position-relative mb-4 mb-xl-8">
                            <div className="row row--horizontal-bordered gutters-y-2 gutters-x-2">
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Aankoopbedrag</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.price ? (
                                                    <PriceFormat value={creditTableData.price} />
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Aanbetaling of inruil</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.finance_deposit ? (
                                                    <PriceFormat value={creditTableData.finance_deposit} />
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Kredietsom / leenbedrag</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.finance_credit ? (
                                                    <PriceFormat value={creditTableData.finance_credit} />
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Slottermijn</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.finance_finalterm ? (
                                                    <PriceFormat value={creditTableData.finance_finalterm} />
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Looptijd in maanden</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.finance_duration ? (
                                                    <>{creditTableData.finance_duration} maanden</>
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Rentepercentage</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData?.finance ? (
                                                    creditTableData.finance * 100
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="row gutters-2">
                                        <div className="col-8">
                                            <p className="text--sm">Totaal terug te betalen bedrag</p>
                                        </div>
                                        <div className="col-4">
                                            <p className="text--sm font-weight-bold">
                                                {creditTableData && creditTableData.finance_totalprice ? (
                                                    <PriceFormat value={creditTableData.finance_totalprice} />
                                                ) : (
                                                    '...'
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {creditTableSnippetData?.text && (
                            <p className="mb-2 mb-xl-6 text--xs">{creditTableSnippetData.text}</p>
                        )}
                    </>
                }
            />
        </>
    );
}
